import { useIdvStatusQuery } from "@faire/deprecated-retailer-visitor-shared/hooks/idv/__internal__/useIdvStatusQuery";
import { strictIsEqual } from "@faire/deprecated-retailer-visitor-shared/hooks/idv/strictIsEqual";
import { IGetRetailerIdvStatusResponse } from "@faire/web-api--source/indigofair/data/IGetRetailerIdvStatusResponse";

import IdvStatus = IGetRetailerIdvStatusResponse.IdvStatus;

export type Status = "yes" | "no" | "unknown";

export const useIdvStatus = () => {
  const { data, isFetching } = useIdvStatusQuery();

  const getIdvStatusState = (idvStatus: IdvStatus): Status => {
    if (isFetching) {
      return "unknown";
    }
    return strictIsEqual(idvStatus, data.idv_status);
  };

  const hasPendingIdv = getIdvStatusState(IdvStatus.HAS_PENDING_IDV_REQUEST);
  const hasNeverReceivedIdv = getIdvStatusState(IdvStatus.NEVER_RECEIVED_IDV);
  const isPendingRiskAnalysis = data.is_pending_risk_analysis;
  const actionRequiredIfNotConfirmed = data.action_required_if_not_confirmed;

  return {
    hasPendingIdv,
    hasNeverReceivedIdv,
    isFetching,
    isPendingRiskAnalysis,
    actionRequiredIfNotConfirmed,
  };
};
